import React from 'react';
import Header from './Header';
import Footer from './Footer';
import FloatingButtons from '../FloatingButtons';
import {Helmet} from "react-helmet";
import { Toaster } from 'react-hot-toast';

const Layout = ({children,title,description,keywords,author}) => {
  return (
    <div>
    <Helmet>
      <meta charSet="utf-8" />
      <meta name="description" content={description}/>
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="/images/logo2.jpeg" />
      <meta property="og:locale" content="ar_IQ" />
      <meta property="og:site_name" content="النخبة ستور" />
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="/images/logo2.jpeg" />
      {/* Canonical */}
      <link rel="canonical" href={typeof window !== 'undefined' ? window.location.href : ''} />
      <title>{title}</title>
    </Helmet>
    <Header/>
    <main style={{minHeight:'90vh'}}>
    <Toaster
      toastOptions={{
        style: {
          background: '#1a1a1a',
          color: '#F9F5EC',
          border: '1px solid rgba(201, 168, 76, 0.25)',
          borderRadius: '10px',
          fontFamily: 'Tajawal, sans-serif',
          fontSize: '0.95rem',
          boxShadow: '0 8px 30px rgba(0, 0, 0, 0.5)',
        },
        success: {
          iconTheme: {
            primary: '#C9A84C',
            secondary: '#0A0A0A',
          },
        },
        error: {
          iconTheme: {
            primary: '#dc3545',
            secondary: '#0A0A0A',
          },
        },
      }}
    />
        {children}
        </main>
     <Footer/>
     <FloatingButtons />
    </div>
  )
}

Layout.defaultProps={
  title: "النخبة ستور | عنوان الفخامة والرقي",
  description: "النخبة ستور - متجر إلكتروني متخصص في بيع أحدث الهواتف الذكية والأجهزة الإلكترونية في العراق",
  keywords: "هواتف,موبايل,أجهزة إلكترونية,العراق,النخبة ستور,هواتف ذكية,ايفون,سامسونج,شراء موبايل",
  author:"النخبة ستور",
}

export default Layout;
